import {PropTypes} from 'react';
export const contentProps = {
  node: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/content.props.js